<template lang="pug">
    div.row.cf__dashboard(v-if="$store.state.isUserLoggedIn")
        div.container.indent
            div.titleBlock Админ панель
            ul.dashboardMenu
                li
                    a.label(href="/admin/words?page=1")
                        include ../../snippets/translate.pug
                        | Список слов
                li
                    a.label(href="/admin/new-words?page=1")
                        include ../../snippets/translate.pug
                        | Модерация слов
                li
                    a.label(href="/admin/users?page=1")
                        include ../../snippets/people.pug
                        | Список пользователей
                li
                    a.label(href="/" target="_blank")
                        include ../../snippets/web.pug
                        | Открыть сайт
                li
                    a.label(href="/admin/feedback?page=1")
                        include ../../snippets/feedback.pug
                        | Обратная связь
                //li
                    a.label(href="/admin/setting")
                        include ../../snippets/settings.pug
                        | Настройки
                li
                    div.label(@click="logout()")
                        include ../../snippets/power.pug
                        | Выйти
</template>

<script>
    export default {
        name: "Dashboard",
        methods: {
            logout() {
                this.$store.dispatch('setToken', null);
                this.$store.dispatch('setUser', null);
            }
        }
    }
</script>
